module.exports = __webpack_public_path__ + "static/media/natwest.893fcb3f.svg";